import { ref } from "vue";
import { formatElapsedTime } from "@/utils/format";
import { dataLayerSearchWidgetUseDuration } from "@/analytics/package-search-form";

export function useAnalyticsTimer() {
  const startTime = ref<Date | null>(null);

  const handleFirstClickForAnalytics = () => {
    if (!startTime.value) {
      startTime.value = new Date();
    }
  };

  const handleSubmitClickForAnalytics = () => {
    if (startTime.value) {
      const endTime = new Date();
      const elapsedTime = endTime.getTime() - startTime.value.getTime();
      const formattedElapsedTime = formatElapsedTime(elapsedTime);
      dataLayerSearchWidgetUseDuration(formattedElapsedTime);
      startTime.value = null;
    }
  };

  return { handleFirstClickForAnalytics, handleSubmitClickForAnalytics };
}
